import React, {useContext, useEffect, useState} from "react";
import NsDatePicker from "../NsDatePicker";
import {Dropdown} from 'primereact/dropdown';
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";
import {InputText} from "primereact/inputtext";
import {MultiSelect} from "primereact/multiselect";
import {TranslateContext} from "../../context/TranslateContext";

export default function NsInputFiltroTabella({
                                                 filtro,
                                                 filter = (val) => {
                                                 },
                                             }) {

    const [val, setVal] = useState();
    const [valDate, setValDate] = useState(filtro.startVal ? new Date(filtro.startVal) : null);
    const {translate} = useContext(TranslateContext);

    // le options potrebbero cambiare, passo flag esplicito che lo segnala
    useEffect(() => {
        if (filtro.filterOptions && filtro?.startVal) {

            // le select multiple passano un array, il cui comportamento è diverso, accetta direttamente i valori iniziali
            if (Array.isArray(filtro?.startVal)) {
                setVal(filtro?.startVal);
            } else {
                let valFiltrato = filtro.filterOptions.filter((el) => el.id == filtro?.startVal);
                if (valFiltrato && valFiltrato.length > 0) {
                    setVal(valFiltrato[0].descrizione);
                }
            }
        } else {
            setVal(filtro?.startVal || undefined);
        }
    }, [filtro.optionsChanged]);

    function getField() {
        if (filtro.filterOptions) {
            if (filtro.isMultiple) {
                return (
                    <MultiSelect
                        value={val}
                        options={filtro.filterOptions.map((opt) => ({label: opt.descrizione, value: opt.id}))}
                        onChange={(event) => {
                            let newVal = event.target.value;
                            setVal(newVal);

                            let optFiltrata = filtro.filterOptions.filter((opt) => opt.descrizione == newVal);
                            if (optFiltrata && optFiltrata.length > 0) {
                                newVal = optFiltrata[0].id;
                            }

                            if (filtro.updateFilter) {
                                filtro.updateFilter(newVal);
                            }
                            if (filtro.filter) {
                                filtro.filter();
                            }

                            filter(newVal);
                        }}
                        display="chip"
                        itemTemplate={filtro.statusItemTemplate}
                        placeholder=""
                        className="p-column-filter sost-form-text-gridfilter maxw-15rem minw-8rem ns-multiselect-filter"
                        panelHeaderTemplate={filtro.panelHeaderTemplate}
                        showClear
                    />
                )
            } else {
                return (
                    <Dropdown
                        value={val}
                        options={filtro.filterOptions.map((opt) => opt.descrizione)}
                        onChange={(event) => {
                            let newVal = event.target.value;
                            setVal(newVal);

                            let optFiltrata = filtro.filterOptions.filter((opt) => opt.descrizione == newVal);
                            if (optFiltrata && optFiltrata.length > 0) {
                                newVal = optFiltrata[0].id;
                            }

                            if (filtro.updateFilter) {
                                filtro.updateFilter(newVal);
                            }
                            if (filtro.filter) {
                                filtro.filter();
                            }

                            filter(newVal);
                        }}
                        itemTemplate={filtro.statusItemTemplate}
                        placeholder=""
                        className="p-column-filter sost-form-text-gridfilter minw-8rem"
                        showClear
                    />
                );
            }
        } else if (filtro.type === 'datepicker') {
            return (
                <NsDatePicker
                    addictionalFiledClasses={"ns-form-datepicker-gridfilter"}
                    dataSelezionata={valDate}
                    setSelectedDate={(date, event) => {
                        setValDate(date);

                        if (filtro.updateFilter) {
                            filtro.updateFilter(date);
                        }
                        if (filtro.filter) {
                            filtro.filter();
                        }

                        filter(date);
                    }}
                />
            );
        } else if (filtro.type === 'boolean') {

            let booleanOptions = [{id: 0, descrizione: translate('No')}, {id: 1, descrizione: translate('Sì')}];

            return (
                <Dropdown
                    value={val}
                    options={booleanOptions.map((opt) => opt.descrizione)}
                    onChange={(event) => {
                        let newVal = event.target.value;
                        setVal(newVal);

                        let optFiltrata = booleanOptions.filter((opt) => opt.descrizione == newVal);
                        if (optFiltrata && optFiltrata.length > 0) {
                            newVal = optFiltrata[0].id;
                        }

                        if (filtro.updateFilter) {
                            filtro.updateFilter(newVal);
                        }
                        if (filtro.filter) {
                            filtro.filter();
                        }

                        filter(newVal);
                    }}
                    itemTemplate={filtro.statusItemTemplate}
                    placeholder=""
                    className="p-column-filter sost-form-text-gridfilter minw-5rem maxw-5rem"
                    showClear
                />
            );
        } else {
            return (
                <IconField className={"w-100"}>
                    <InputIcon className="fas fa-search"/>
                    <InputText
                        v-model="value1"
                        className={"sost-form-text-gridfilter"}
                        value={val || ''}
                        onChange={(event) => {
                            let newVal = event.target.value;
                            setVal(newVal);
                            if (filtro.updateFilter) {
                                filtro.updateFilter(newVal);
                            }
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                if (filtro.filter) {
                                    filtro.filter();
                                }
                                filter(val);
                            }
                        }}
                    />
                </IconField>
            );
        }
    }

    return <div className={"sost-form-text-gridfilter-container"}>
        {
            getField()
        }
    </div>

}